<!-- 发起弹窗 -->
<template>
  <div>
    <el-dialog
      :title="$t('text.withdrawal')"
      :visible="isShowWithdrawDialog"
      width="30%"
      :close-on-click-modal="false"
      @close="handleDialog"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="150px">
        <el-form-item :label="$t('text.availableBalance')">
          <el-input
            size="small"
            type="text"
            v-model="balance"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.withdrawalAmount')" prop="amount">
          <el-input
            size="small"
            type="text"
            v-model="form.amount"
            :placeholder="$t('message.inputWithdrawalAmount')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.collectionAddress')" prop="collectAccount">
          <el-input
            size="small"
            type="text"
            v-model="form.collectAccount"
            :placeholder="$t('message.inputYourWalletAddress')"
            show-word-limit
            maxlength="42"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.remark')" prop="remark">
          <el-input
            size="small"
            type="textarea"
            v-model="form.remark"
            :placeholder="$t('message.inputRechargeWithdrawRemark')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="submitting" @click="handleDialog">{{ $t('text.cancel') }}</el-button>
        <el-button type="primary" :loading="submitting" :disabled="submitting" @click="submit">{{ $t('text.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    isShowWithdrawDialog: {
      type: Boolean,
      default: false
    },
    balance: {
      type: Number | String,
      default: 0
    },
    freezeBalance: {
      type: Number | String,
      default: 99
    }
  },
  data() {
    return {
      submitting: false,
      form: {
        type: "01",
        amount: "",
        collectAccount: "",
        remark: ""
      },
      rules: {
        amount: [
          { required: true, validator: this.validateAmount, trigger: "blur" }
        ],
        collectAccount: [
          { required: true, message: this.$t('message.inputYourWalletAddress'), trigger: "blur" },
          { max: 42, message: this.$t('message.inputYourWalletAddress'), trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    validateAmount(rule, value, callback) {
      var submitAmount = parseFloat(value);
      if (isNaN(submitAmount) || submitAmount <= 0) {
        callback(new Error(this.$t('message.inputWithdrawalAmount')));
      } else {
        var comper = parseFloat(this.balance);
        var freeBla = parseFloat(this.freezeBalance);
        if (comper - freeBla < submitAmount) {
          callback(
            new Error(this.$t('message.invalidWithdrawalAmount'))
          );
        } else {
          callback();
        }
      }
    },
    handleDialog() {
      if (this.submitting) {
        return;
      }
      this.$refs["form"].resetFields();
      this.form = {
        type: "01",
        amount: "",
        collectAccount: "",
        remark: ""
      };
      this.$emit("update:isShowWithdrawDialog", false);
    },
    submit() {
      if (this.submitting) {
        return;
      }
      this.submitting = true;
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.submitting = false;
          return;
        }
        const params = {
          ...this.form
        };
        this.$axios
          .post("/depositWithdraw/addDepositWithdraw", params)
          .then((res) => {
            if (res.code === 200) {
              this.$notify({
                title: this.$t('text.prompt'),
                message: res.msg,
                type: "success"
              });
              this.submitting = false;
              this.handleDialog();
              this.$bus.$emit("refresh"); //通知刷新
            } else {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: res.msg
              });
            }
          })
          .catch((error) => {
            const message = error && error.response && error.response.data && error.response.data.msg;
            this.$notify.error({
              title: this.$t('text.prompt'),
              message: message || this.$t('message.submitFailed')
            });
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
}
</style>
